
import { defineComponent } from "vue";
import api, { Employee } from "../../api/backend-api";
import { AxiosError } from "axios";

import BstkCSVImport from "../../components/BstkCSVImport.vue";
import BstkCSVInput from "../../components/BstkCSVInput.vue";
import BstkCSVToggleHeaders from "../../components/BstkCSVToggleHeaders.vue";
import BstkCSVToggleCreateMissing from "../../components/BstkCSVToggleCreateMissing.vue";
import BstkCSVErrors from "../../components/BstkCSVErrors.vue";
import BstkCSVMap from "../../components/BstkCSVMap.vue";


interface ImportStruct {
    [key: string]: string|undefined;
  employee_uid: string;
  company_uid: string;
  account_id: string;
  email?: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  message?: string;
  action?: string;
  status?: string;
}

interface ImportContainer {
  records: ImportStruct[],
  errors: ImportStruct[],
  total: number,
  to_change: number,
  to_add: number
}

interface State {
  msg: string;
  csv_file: string;
  csv_data: [];
  csv_map: [];
  csv_fields: Record<string, any>;
  import_list: ImportContainer;
  import_checked: number;
  errors: AxiosError[];
}

export default defineComponent({
  name: "SheqsyEmployeeBulk",
  components: {
    BstkCSVImport,
    BstkCSVInput,
    BstkCSVToggleHeaders,
    BstkCSVToggleCreateMissing,
    BstkCSVErrors,
    BstkCSVMap,
  },
  data: (): State => {
    return {
      msg: "Sheqsy Bulk Employee Update",
      csv_file: '',
      csv_data: [],
      csv_map: [],
      csv_fields: {
        employee_uid: {required: true, label: 'Employee UId'},
        account_id: {required: true, label: 'Account ID'},
        company_uid: { required: false, label: 'Company UId'},
        email: {required: false, label: 'Email'},
        phone_number: {required: false, label: 'Phone'},
        first_name: {required: false, label: 'First name'},
        last_name: {required: false, label: 'Last name'},
      },
      import_list: {
        'records': [],
        'errors': [],
        'total': 0,
        'to_change': 0,
        'to_add': 0
      },
      import_checked: 0,
      errors: [],
    };
  },
  methods: {
    updateCsvMap(data: []) {
      this.csv_map = data;
    },
    checkImport() {

      this.import_checked = 0
      if (this.import_list) {
        this.import_list.to_change = 0;
        this.import_list.to_add = 0;
        this.import_list.records = [];
        this.import_list.errors = [];
      }
      this.csv_data.forEach((record: ImportStruct) => {
        if (!this.import_list) {
          return
        }

        api
          .batchGetEmployee(record.employee_uid)
          .then((response) => {
            if (!this.import_list) {
              return
            }
            if (response.data.ReferenceId == record.account_id) {
              record.status = 'unchanged'
            } else {
              this.import_list.to_change++
              record.status = 'update'
            }
            this.import_checked++
          })
          .catch((error: AxiosError) => {
            if (!this.import_list) {
              return
            }
            if (error.response?.status == 404) {
              if (record.action == 'replace') {
               this.import_list.to_add++
                record.status = 'add'
              } else {
                record.status = 'skip'
              }
              this.import_checked++
            }
          });

      })
    },
    processImport() {
      if (this.import_list) {
        this.import_list.records = [];
        this.import_list.errors = [];
      }
      this.csv_data.forEach((record: ImportStruct) => {
        if (!this.import_list) {
          return
        }

        if (!record.account_id || record.account_id.toLowerCase() == "null") {
          record.account_id = '9999'
        }

        if (record.status == 'unchanged') {
          record.message = 'Not changed'
          this.import_list.total++
          this.awaitImportValidation()
          return;
        }

        if (record.status == 'update') {
          this.import_list.total++
          this.import_list.records.push(record)
          this.awaitImportValidation()
          return;
        }

        if (record.status == 'add') {
          this.import_list.total++
          this.import_list.records.push(record)
          this.awaitImportValidation()
          return;
        }

        if (record.status == 'skip') {
          record.message = 'Skipped'
          this.import_list.total++
          this.awaitImportValidation()
          return;
        }


      })
    },
    awaitImportValidation() {
      if (!this.import_list?.total) {
        return
      }
      console.log(`${this.import_list.total} loaded out of ${this.csv_data.length}`)
      if (this.import_list.total == this.csv_data.length) {
        this.doImport()
      }
    },
    doImport() {
      if (!this.import_list) {
        return
      }
      let employee = { } as Employee;

      this.import_list.records.forEach((element, index) => {
        employee.EmployeeUId = element.employee_uid;
        employee.ReferenceId = element.account_id;

        if (element.status == 'add') {
          if (element.company_uid !== undefined) {
            employee.CompanyUId = element.company_uid;
          }
          if (element.email !== undefined) {
            employee.Email = element.email;
          }
          if (element.phone_number !== undefined) {
            employee.PhoneNumber = element.phone_number;
          }
          if (element.first_name !== undefined) {
            employee.FirstName = element.first_name;
          }
          if (element.last_name !== undefined) {
            employee.LastName = element.last_name;
          }
          this.doCreate(employee, index)
        }
        if (element.status == 'update') {
          this.doSave(employee, index)
        }
      });
    },
    doCreate(employee: Employee, index: number) {
      console.log(`Creating employee ${employee.EmployeeUId} at #${index}`)
      api
        .batchCreateEmployee(employee)
        .then(() => {
          if (this.import_list?.records[index])
            this.import_list.records[index].message = 'Created';
        })
        .catch((error: AxiosError) => {
          console.log(error);
          this.errors.push(error);
          if (this.import_list?.records[index])
            this.import_list.records[index].message = 'Failed';
        });
    },
    doSave(employee: Employee, index: number) {
      console.log(`Saving employee ${employee.EmployeeUId} at #${index}`)
      api
        .batchSaveEmployee(employee)
        .then(() => {
          if (this.import_list?.records[index])
            this.import_list.records[index].message = 'Updated';
        })
        .catch((error: AxiosError) => {
          console.log(error);
          this.errors.push(error);
          if (this.import_list?.records[index])
            this.import_list.records[index].message = 'Failed';
        });
    },
  },
});
